<template>
<router-link :to="link">
	<div class="image-container cursor-pointer">
		<figure class="image">
	    	<img :src="src" :alt="innerText" />
		</figure>
		<div class="middle">
	    	<span class="link-text">{{innerText}}</span>
		</div>
	</div>
</router-link>
</template>

<script>
export default {
  name: 'PreviewItem',
  props: {
    src: {
      type: String,
      required: true
    },
    innerText: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.image-container {
	opacity: 0.8;
	color: white;
	display: flex;
  	justify-content: center;
  	align-content: center;
  	flex-direction: column;
	position: relative;
	-webkit-transition: .3s ease;
	transition: .3s ease;
	width: fit-content;
	margin: auto;
}

.image-container:hover {
	opacity: 1;
	color: white;
}

.image-container:hover >>> img {
	transform: scale(0.9);
	transition: .3s ease;
}

.image-container:hover >>> .middle {
	background-color: rgba(0, 0, 0, 0.8);
	transition: .3s ease;
}

img {
	box-shadow: 5px 10px 5px rgba(0, 0, 0, 0.25);
	max-width: 25em;
	height: auto;
	margin: auto;
	border-radius: 10px;
	transition: .3s ease;
}

.middle {
	background: rgba(0, 0, 0, 0.4);
	border-radius: 10px;
	padding: 0.25rem;
	font-weight: 400 !important;
	font-size: 1.75rem;
	left: 50%;
	position: absolute;
	-webkit-transform: translate(-50%,-50%);
	transform: translate(-50%,-50%);	
	text-align: center;
	top: 50%;
	-webkit-transition: .3s ease;
	transition: .3s ease;
}

</style>
